import { Button, ModalBox, Skeleton, useModalContext } from '@fourthwall/components';
import React from 'react';
export const RefundModalSkeleton = ({ member }) => {
    const modal = useModalContext();
    return (React.createElement(ModalBox, { title: React.createElement(React.Fragment, null,
            "Refund ",
            member.nickname), size: "medium", buttons: [
            React.createElement(Button, { label: "Close", appearance: "secondary", onClick: modal.close }),
            React.createElement(Button, { label: "Refund", appearance: "destructive", loading: true }),
        ], onClose: modal.close },
        React.createElement(Skeleton, { gap: 16 },
            React.createElement(Skeleton.Shape, { width: 225, height: 24 }),
            React.createElement(Skeleton, { gap: 10 },
                React.createElement(Skeleton.Shape, { width: "100%", height: 48 }),
                React.createElement(Skeleton.Shape, { width: "100%", height: 48 }),
                React.createElement(Skeleton.Shape, { width: "100%", height: 48 })))));
};
